import React, { Component } from 'react';
import { connect } from "react-redux";
import '../ri.scss';
import Wrapper from "../../../helpers/wrapper";
import Col from "react-bootstrap/esm/Col";
import IconPerformance from '../../../../assets/images/icons/performanceIcon';
import IconRemarketing from '../../../../assets/images/icons/remarketingIcon';
import IconDownload from '../../../../assets/images/icons/downloadIcon'
import RIPageHeader from '../../../layout/ri-pageheader/ri-pageheader';
import { Carousel } from '../../../shared/components/carousel/carousel';
import { ChartCard } from '../../../shared/components/cards/chartcard/chartcard'
import Linegraph_sparkline from '../../../shared/components/charts/Linegraph_sparkline';
import MultipartGaugeChart from '../../../shared/components/charts/MultipartGaugeChart'
import IconWebsite from '../../../../assets/images/icons/websiteIcon';
import HighlightingLineChart from '../../../shared/components/charts/HighlightingLineChart';
import RiTreegraph from '../../../shared/components/charts/RiTreegraph';
import RiHeatMap from '../../../shared/components/charts/RiHeatMap';
import { Tab } from "../../../shared/components/tabs/tab";
import { TabNav } from "../../../shared/components/tabs/tabnav";
import { SellthroughPerformance } from './SellthroughPerformance';
import { SellthroughExceptions } from './SellthroughExceptions';
import { Dropdown } from "../../../shared/components/dropdown/dropdown"
import { Breadcrumb, Container, Image, ProgressBar } from 'react-bootstrap';
import RiMapFilter from '../ri-mapfilter/RiMapFilter';
import IndiaMap from '../../../shared/components/map/indiamap/indiamap';
import { Loader } from '../../../shared/components/loader/loader';

import IconPdf from "../../../../assets/images/icons/pdfIcon";
import DatePicker from "../../../shared/components/datepicker/datepicker";

import StickyLogo from "../../../../assets/images/icons/icon.png";
import UKMap from "../../../shared/components/map/ukmap/ukmap";

import BRAND1 from "../../../../assets/images/brands/brand1.png";
import BRAND2 from "../../../../assets/images/brands/brand2.png";
import BRAND3 from "../../../../assets/images/brands/brand3.png";
import BRAND4 from "../../../../assets/images/brands/brand4.png";
import BRAND5 from "../../../../assets/images/brands/brand5.png";
import BrandDropdown from "../../../shared/components/dropdown/brandDropdown";
import PageHeader from '../../../../../components/layout/pageHeader';
import USMap from '../../../shared/components/map/usmap/usmap';
import ChartExport from '../../../shared/components/export/ChartExport';
import { API_URL } from '../../../../../constants/constants';

export class SellThroughOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {

      brandsDropdownOptions: [
        {
          value: "pulsar",
          label: "Pulsar",
          icon: (
            <img
              src={BRAND1}
              style={{ width: "25px", height: "25px", borderRadius: "100%" }}
            />
          ),
        },
        {
          value: "platina",
          label: "Platina",
          icon: (
            <img
              src={BRAND2}
              style={{ width: "25px", height: "25px", borderRadius: "100%" }}
            />
          ),
        },
        {
          value: "ct",
          label: "CT",
          icon: (
            <img
              src={BRAND3}
              style={{ width: "25px", height: "25px", borderRadius: "100%" }}
            />
          ),
        },
        {
          value: "avenger",
          label: "Avenger",
          icon: (
            <img
              src={BRAND4}
              style={{ width: "25px", height: "25px", borderRadius: "100%" }}
            />
          ),
        },
        {
          value: "dominar",
          label: "Dominar",
          icon: (
            <img
              src={BRAND5}
              style={{ width: "25px", height: "25px", borderRadius: "100%" }}
            />
          ),
        }
      ],

      selectedBrandDropdownOption: "",

      dropdown_options: [{ "value": "markdown", "label": "Markdown" }, { "value": "nsv", "label": "NSV" }, { "value": "units-sold", "label": "Units Sold" }, { "value": "mix", "label": "Mix%" }, { "value": "nm", "label": "NM%" }, { "value": "asp", "label": "ASP" }, { "value": "sell-thru", "label": "Sell Thru" }],
      markdown_dropdown_options: [{ "value": "promo", "label": "Promo" }, { "value": "nonpromo", "label": "Non Promo" }],
      markdownasp_dropdown_options: [{ "value": "markdown", "label": "Markdown" }, { "value": "asp", "label": "Asp" }],
      linesparkgraph: [{ "date": "2012-07-27", "value": 13 }, { "date": "2012-07-28", "value": 10 }, { "date": "2012-07-29", "value": 15 }, { "date": "2012-07-30", "value": 15 }, { "date": "2012-07-31", "value": 15 }, { "date": "2012-08-01", "value": 15 }, { "date": "2012-08-02", "value": 15 }, { "date": "2012-08-03", "value": 19 }, { "date": "2012-08-04", "value": 16 }, { "date": "2012-08-05", "value": 15 }, { "date": "2012-08-06", "value": 19 }, { "date": "2012-08-07", "value": 17 }, { "date": "2012-08-08", "value": 18 }],
      selltrend: [{ "month": "Jan", "value1": 12, "value2": 16, "value3": 13, "value4": 20, "value5": 15, "value6": 10 }, { "month": "Feb", "value1": 20, "value2": 22, "value3": 15, "value4": 24, "value5": 18, "value6": 15 }, { "month": "Mar", "value1": 25, "value2": 26, "value3": 18, "value4": 26, "value5": 22, "value6": 20 }, { "month": "Apr", "value1": 30, "value2": 32, "value3": 22, "value4": 30, "value5": 28, "value6": 26 }, { "month": "May", "value1": 35, "value2": 39, "value3": 25, "value4": 36, "value5": 33, "value6": 30 }, { "month": "June", "value1": 43, "value2": 46, "value3": 33, "value4": 41, "value5": 39, "value6": 37 }, { "month": "Jul", "value1": 47, "value2": 50, "value3": 41, "value4": 46, "value5": 42, "value6": 44 }, { "month": "Aug", "value1": 54, "value2": 56, "value3": 45, "value4": 50, "value5": 48, "value6": 51 }, { "month": "Sep", "value1": 57, "value2": 59, "value3": 51, "value4": 53, "value5": 52, "value6": 55 }, { "month": "Oct", "value1": 61, "value2": 64, "value3": 56, "value4": 60, "value5": 55, "value6": 59 }, { "month": "Nov", "value1": 70, "value2": 66, "value3": 58, "value4": 65, "value5": 61, "value6": 64 }, { "month": "Dec", "value1": 101, "value2": 72, "value3": 64, "value4": 70, "value5": 68, "value6": 72 }],
      treegraph: [{ "name": "APPARELS", "nsv": 249868959, "value": 811, "asp": 810.61, "units_sold": 308247, "store_nsv": 1119151444, "total_nsv": 1119151444, "nsv_mix": 85.18, "color": "#038673" }, { "name": "LIFESTYLE", "nsv": 42912209, "value": 868, "asp": 868.25, "units_sold": 49424, "store_nsv": 1119151444, "total_nsv": 1119151444, "nsv_mix": 14.63, "color": "#038673" }, { "name": "NSM & OTHERS", "nsv": 553437, "value": 3, "asp": 2.98, "units_sold": 185639, "store_nsv": 1119151444, "total_nsv": 1119151444, "nsv_mix": 0.19, "color": "#d51f30" }],
      selectedSubNav: 'Performance',
      markdownData: [{ "rate": "20", "category": "Dresses", "value": 2990 }, { "rate": "30", "category": "Dresses", "value": 2520 }, { "rate": "40", "category": "Dresses", "value": 3530 }, { "rate": "50", "category": "Dresses", "value": 2230 }, { "rate": "60", "category": "Dresses", "value": 2325 }, { "rate": "70", "category": "Dresses", "value": 3309 }, { "rate": "80", "category": "Dresses", "value": 5657 }, { "rate": "20", "category": "Trousers", "value": 3346 }, { "rate": "30", "category": "Trousers", "value": 2725 }, { "rate": "40", "category": "Trousers", "value": 3052 }, { "rate": "50", "category": "Trousers", "value": 3876 }, { "rate": "60", "category": "Trousers", "value": 4453 }, { "rate": "70", "category": "Trousers", "value": 3972 }, { "rate": "80", "category": "Trousers", "value": 4644 }, { "rate": "20", "category": "Footwear", "value": 4468 }, { "rate": "30", "category": "Footwear", "value": 3306 }, { "rate": "40", "category": "Footwear", "value": 3906 }, { "rate": "50", "category": "Footwear", "value": 4413 }, { "rate": "60", "category": "Footwear", "value": 4726 }, { "rate": "70", "category": "Footwear", "value": 4584 }, { "rate": "80", "category": "Footwear", "value": 5717 }, { "rate": "20", "category": "Sports", "value": 8145 }, { "rate": "30", "category": "Sports", "value": 7177 }, { "rate": "40", "category": "Sports", "value": 5657 }, { "rate": "50", "category": "Sports", "value": 6802 }, { "rate": "60", "category": "Sports", "value": 8159 }, { "rate": "70", "category": "Sports", "value": 8449 }, { "rate": "80", "category": "Sports", "value": 9453 }, { "rate": "20", "category": "Luggage", "value": 3689 }, { "rate": "30", "category": "Luggage", "value": 3081 }, { "rate": "40", "category": "Luggage", "value": 6525 }, { "rate": "50", "category": "Luggage", "value": 6228 }, { "rate": "60", "category": "Luggage", "value": 6917 }, { "rate": "70", "category": "Luggage", "value": 6568 }, { "rate": "80", "category": "Luggage", "value": 6405 }, { "rate": "20", "category": "Accessories", "value": 4022 }, { "rate": "30", "category": "Accessories", "value": 3063 }, { "rate": "40", "category": "Accessories", "value": 3638 }, { "rate": "50", "category": "Accessories", "value": 3968 }, { "rate": "60", "category": "Accessories", "value": 4070 }, { "rate": "70", "category": "Accessories", "value": 4019 }, { "rate": "80", "category": "Accessories", "value": 4548 }, { "rate": "20", "category": "Bottomwear", "value": 3503 }, { "rate": "30", "category": "Bottomwear", "value": 2842 }, { "rate": "40", "category": "Bottomwear", "value": 2808 }, { "rate": "50", "category": "Bottomwear", "value": 3063 }, { "rate": "60", "category": "Bottomwear", "value": 3081 }, { "rate": "70", "category": "Bottomwear", "value": 2745 }, { "rate": "80", "category": "Bottomwear", "value": 2527 }, { "rate": "20", "category": "Cosmetics", "value": 3503 }, { "rate": "30", "category": "Cosmetics", "value": 2842 }, { "rate": "40", "category": "Cosmetics", "value": 2808 }, { "rate": "50", "category": "Cosmetics", "value": 2399 }, { "rate": "60", "category": "Cosmetics", "value": 2842 }, { "rate": "70", "category": "Cosmetics", "value": 2825 }, { "rate": "80", "category": "Cosmetics", "value": 2527 }, { "rate": "20", "category": "Ethnic", "value": 3503 }, { "rate": "30", "category": "Ethnic", "value": 2842 }, { "rate": "40", "category": "Ethnic", "value": 2808 }, { "rate": "50", "category": "Ethnic", "value": 4726 }, { "rate": "60", "category": "Ethnic", "value": 3052 }, { "rate": "70", "category": "Ethnic", "value": 4019 }, { "rate": "80", "category": "Ethnic", "value": 2527 }, { "rate": "20", "category": "Denims", "value": 2990 }, { "rate": "30", "category": "Denims", "value": 2520 }, { "rate": "40", "category": "Denims", "value": 2334 }, { "rate": "50", "category": "Denims", "value": 3025 }, { "rate": "60", "category": "Denims", "value": 4431 }, { "rate": "70", "category": "Denims", "value": 3081 }, { "rate": "80", "category": "Denims", "value": 4468 }, { "rate": "20", "category": "Blazers", "value": 3346 }, { "rate": "30", "category": "Blazers", "value": 2725 }, { "rate": "40", "category": "Blazers", "value": 3052 }, { "rate": "50", "category": "Blazers", "value": 3876 }, { "rate": "60", "category": "Blazers", "value": 4453 }, { "rate": "70", "category": "Blazers", "value": 3972 }, { "rate": "80", "category": "Blazers", "value": 4644 }, { "rate": "20", "category": "T-shirts", "value": 4468 }, { "rate": "30", "category": "T-shirts", "value": 3306 }, { "rate": "40", "category": "T-shirts", "value": 3906 }, { "rate": "50", "category": "T-shirts", "value": 4413 }, { "rate": "60", "category": "T-shirts", "value": 4726 }, { "rate": "70", "category": "T-shirts", "value": 4584 }, { "rate": "80", "category": "T-shirts", "value": 5717 }, { "rate": "20", "category": "Shirts", "value": 8145 }, { "rate": "30", "category": "Shirts", "value": 7177 }, { "rate": "40", "category": "Shirts", "value": 5657 }, { "rate": "50", "category": "Shirts", "value": 6802 }, { "rate": "60", "category": "Shirts", "value": 8159 }, { "rate": "70", "category": "Shirts", "value": 8449 }, { "rate": "80", "category": "Shirts", "value": 9453 }, { "rate": "20", "category": "Shoes", "value": 3689 }, { "rate": "30", "category": "Shoes", "value": 3081 }, { "rate": "40", "category": "Shoes", "value": 6525 }, { "rate": "50", "category": "Shoes", "value": 6228 }, { "rate": "60", "category": "Shoes", "value": 6917 }, { "rate": "70", "category": "Shoes", "value": 6568 }, { "rate": "80", "category": "Shoes", "value": 6405 }, { "rate": "20", "category": "Watches", "value": 4022 }, { "rate": "30", "category": "Watches", "value": 3063 }, { "rate": "40", "category": "Watches", "value": 3638 }, { "rate": "50", "category": "Watches", "value": 3968 }, { "rate": "60", "category": "Watches", "value": 4070 }, { "rate": "70", "category": "Watches", "value": 4019 }, { "rate": "80", "category": "Watches", "value": 4548 }, { "rate": "20", "category": "Watches", "value": 4022 }, { "rate": "30", "category": "Watches", "value": 3063 }, { "rate": "40", "category": "Watches", "value": 3638 }, { "rate": "50", "category": "Watches", "value": 3968 }, { "rate": "60", "category": "Watches", "value": 4070 }, { "rate": "70", "category": "Watches", "value": 4019 }, { "rate": "80", "category": "Watches", "value": 4548 }, { "rate": "20", "category": "Flipflop", "value": 2990 }, { "rate": "30", "category": "Flipflop", "value": 2520 }, { "rate": "40", "category": "Flipflop", "value": 2334 }, { "rate": "50", "category": "Flipflop", "value": 3876 }, { "rate": "60", "category": "Flipflop", "value": 2725 }, { "rate": "70", "category": "Flipflop", "value": 3063 }, { "rate": "80", "category": "Flipflop", "value": 6820 }],
      mtd_gaugedata: [{ "hand1": 50 }, { "hand2": 49 }, { "hand3": 46 }, { "hand4": 52 }],
      qtd_gaugedata: [{ "hand1": 66 }, { "hand2": 63 }, { "hand3": 67 }, { "hand4": 65 }],
      ytd_gaugedata: [{ "hand1": 72 }, { "hand2": 66 }, { "hand3": 69 }, { "hand4": 70 }],

      first_start_date: props.start_date,
      first_end_date: props.end_date,
      second_start_date: props.previous_start_date,
      second_end_date: props.previous_end_date,

      isDatePickerOpen: false,
      is_scroll: false,

      // MAP
      map_zone: '',
      map_state: '',
      map_city: '',
      map_store_code: "",
      map_store_name: '',


      // MAP FILTER
      map_store_category: '',
      map_store_type: '',
      map_store_size: '',


      //map filter
      map_filter_category_list: [
        { name: 'Metro', checked: false },
        { name: 'Non-Metro', checked: false },
      ],
      map_filter_storetype_list: [
        { name: 'New', checked: false },
        { name: 'LTL', checked: false },
        { name: 'Mature', checked: false },
      ],
      map_filter_storesize_list: [],

      mapBreadcrumbList: [],
      mapBreadcrumbsNorthPoint: '',
      mapBreadcrumbsSouthPoint: '',
      mapBreadcrumbsCenterPoint: '',

      data: "",
      MapMarker: "",
      North_point: [72.6416015625, 37.71859032558816],
      South_point: [93.1640625, 5.7908968128719565],
      map_level: 0,
      center_point: [0, 0],

      custom_current_basket_size: 5.67,
      custom_last_basket_size: 5.35,
      rangetype: "nsv_ach",

      Deep_Dive_level: 0,
      Deep_Dive_Name: [],
      category_dropdown_value: "nsv",


    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props != nextProps) {
      this.setState({
        first_start_date: nextProps.start_date,
        first_end_date: nextProps.end_date,
        second_start_date: nextProps.previous_start_date,
        second_end_date: nextProps.previous_end_date,
      });
    }
  }

  componentDidMount() {
    this.state.is_India_map_loaded = false;
    this.state.country = this.props.country;
    this.getMapdetails();
    this.forceUpdate();
    window.addEventListener("scroll", this.handleScroll);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.start_date !== this.props.start_date ||
      prevProps.end_date !== this.props.end_date ||
      prevProps.previous_start_date !== this.props.previous_start_date ||
      prevProps.previous_end_date !== this.props.previous_end_date
    ) {
      this.state.is_India_map_loaded = false;
      this.getMapdetails();
    }
  }


  getUrlCountryParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if ((sParameterName[0]).toLowerCase() === sParam.toLowerCase()) {
        return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
    return "";
  }

  isNull(object) {
    for (const [key, value] of Object.entries(object)) {
      if (typeof value === "object" && value !== null) {
        this.isNull(value);
      } else if (!value) {
        object[key] = 0;
      }
    }
    return object;
  }

  //India map details
  getMapdetails() {
    let result = [];

    let start_date = this.state.first_start_date;
    let end_date = this.state.first_end_date;
    //map filter
    let category = this.state.map_store_category;
    let store_type = this.state.map_store_type;
    let store_size = this.state.map_store_size;
    let country = this.state.country != null ? (this.state.country).toUpperCase() : "IN";

    const url = API_URL + "ri/zones/";

    fetch(url, {
      method: "POST",
      body: "start_date=" + start_date +
        "&end_date=" + end_date +
        "&city_type=" + category +
        "&store_type=" + store_type +
        "&store_size=" + store_size +
        "&country=" + country,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        'Authorization': ' Bearer ' + localStorage.getItem("token")
      },
    })
      .then((res) => res.json())
      .then(
        (result1) => {
          let varIndiaMapData = result1.data;
          this.setState({
            MapMarker: varIndiaMapData,
            is_India_map_loaded: true,
          });
        },
        (error) => { }
      );
  }

  getIndiaMapCityDetails() {
    let result = [];

    let start_date = this.state.first_start_date;
    let end_date = this.state.first_end_date;
    let map_zone = this.state.map_zone;
    //map filter
    let category = this.state.map_store_category;
    let store_type = this.state.map_store_type;
    let store_size = this.state.map_store_size;

    const url = API_URL + "ri/cities/";

    fetch(url, {
      method: "POST",
      body: "start_date=" + start_date +
        "&end_date=" + end_date +
        "&map_zone=" + map_zone +
        "&city_type=" + category +
        "&store_type=" + store_type +
        "&store_size=" + store_size,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        'Authorization': ' Bearer ' + localStorage.getItem("token")
      },
    })
      .then((res) => res.json())
      .then(
        (result1) => {
          let varIndiaMapData = result1.data;
          this.setState({
            MapMarker: varIndiaMapData,
            is_India_map_loaded: true,
            map_level: 1
          });
        },
        (error) => { }
      );

  }

  getIndiaMapStoresDetails() {
    let result = [];

    let start_date = this.state.first_start_date;
    let end_date = this.state.first_end_date;
    let map_zone = this.state.map_zone;
    let map_city = this.state.map_city;
    //map filter
    let category = this.state.map_store_category;
    let store_type = this.state.map_store_type;
    let store_size = this.state.map_store_size;

    const url = API_URL + "ri/stores/";

    fetch(url, {
      method: "POST",
      body: "start_date=" + start_date +
        "&end_date=" + end_date +
        "&map_zone=" + map_zone +
        "&map_city=" + map_city +
        "&city_type=" + category +
        "&store_type=" + store_type +
        "&store_size=" + store_size,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        'Authorization': ' Bearer ' + localStorage.getItem("token")
      },
    })
      .then((res) => res.json())
      .then(
        (result1) => {
          let varIndiaMapData = result1.data;
          this.setState({
            MapMarker: varIndiaMapData,
            is_India_map_loaded: true,
            map_level: 2
          });
        },
        (error) => { }
      );

  }

  setSelectedSubNav = (tab) => {
    this.setState({ selectedSubNav: tab });
  }

  handleRiMapFilterCallback = (childData) => {

    let storeCategory = [];
    let storeType = [];
    let storeSize = [];

    storeCategory.push(childData[0]);
    storeType.push(childData[1]);
    storeSize.push(childData[2]);

    this.state.map_store_category = storeCategory;
    this.state.map_store_type = storeType;
    this.state.map_store_size = storeSize;

    //0 zone level
    //get city
    if (this.state.map_level == 0) {
      this.state.is_India_map_loaded = false;
      this.getMapdetails();
    }

    //1 city level
    else if (this.state.map_level == 1) {
      this.state.is_India_map_loaded = false;
      this.getIndiaMapCityDetails();
    }

    //2 store level
    else if (this.state.map_level == 2) {
      this.state.is_India_map_loaded = false;
      this.getIndiaMapStoresDetails();
    }

    //3 store code level data 
    else if (this.state.map_level == 3) {
    }

    this.state.map_filter_storesize_list = childData[3];
    this.forceUpdate();

  };

  handleRISalesSummaryIndiaMapCallBack = (childData) => {

    this.state.North_point = childData[0];
    this.state.South_point = childData[1];
    this.state.center_point = childData[2];
    this.state.map_zone = childData[3];
    this.state.map_city = childData[4];
    this.state.map_store_code = childData[5];
    this.state.map_store_name = childData[6];


    //0 zone level
    //get city
    if (this.state.map_level == 0) {
      this.state.is_India_map_loaded = false;
      this.getIndiaMapCityDetails();
      this.state.mapBreadcrumbList = ['All ZONES', this.state.map_zone];
    }

    //1 city level
    else if (this.state.map_level == 1) {
      this.state.is_India_map_loaded = false;
      this.getIndiaMapStoresDetails();
      this.state.mapBreadcrumbList = ['All ZONES', this.state.map_zone, this.state.map_city];
    }

    //2 store level
    else if (this.state.map_level == 2) {
      this.state.mapBreadcrumbList = ['All ZONES', this.state.map_zone, this.state.map_city, this.state.map_store_name];
      // this.getIndiaMapStoresDetails();
    }
    //3 store code level data 
    else if (this.state.map_level == 3) {
      this.state.mapBreadcrumbList = ['All ZONES', this.state.map_zone, this.state.map_city, this.state.map_store_name];
      // this.getIndiaMapStoresDetails();
    }

    this.state.mapBreadcrumbsCenterPoint = this.state.center_point;
    this.state.mapBreadcrumbsNorthPoint = this.state.North_point;
    this.state.mapBreadcrumbsSouthPoint = this.state.South_point;


    this.forceUpdate();
  };

  handleCallback = (childData) => {

    this.state.first_start_date = childData[0];
    this.state.first_end_date = childData[1];
    this.state.second_start_date = childData[2];
    this.state.second_end_date = childData[3];

    this.state.is_India_map_loaded = false;

    this.getMapdetails();
    this.forceUpdate();
    this.handleCallback2();
  };

  handleCallback2 = () => {
    this.setState({ isDatePickerOpen: !this.state.isDatePickerOpen });
  };

  handleScroll = () => {
    if (window.pageYOffset > 1) {
      if (!this.state.is_scroll) {
        this.setState({ is_scroll: true });
      }
    } else {
      if (this.state.is_scroll) {
        this.setState({ is_scroll: false });
      }
    }
  };

  onClickRiExport = () => {
    window.print('height=2000,width=2000')
  }

  handleNSVdeepDiveCallback = (childData) => {
  }

  handleNSVdeepDiveCallback2 = (childData) => {
  }

  // BRAND DROPDOWN
  brandDropdownSelectionHandler = (e) => {
    if (e === null) {
      this.state.selectedBrandDropdownOption = "";
    } else {
      this.state.selectedBrandDropdownOption = e;
    }
    this.forceUpdate();
  };

  mapBreadcrumbs = (evt, index) => {
    this.state.mapBreadcrumbList.splice(index);

    // level 0
    // all zone
    if (index == 1) {
      this.state.map_zone = '';
      this.state.map_city = '';
      this.state.map_store_code = '';
      this.state.map_store_name = '';
      this.state.map_store_category = '';
      this.state.map_store_type = '';
      this.state.map_store_size = '';
      this.state.map_level = 0;
      this.state.center_point = [0, 0];
      this.state.North_point = [72.6416015625, 37.71859032558816];
      this.state.South_point = [93.1640625, 5.7908968128719565];
      this.state.is_India_map_loaded = false;

      this.getMapdetails();
      this.forceUpdate();
    }
    // level 1
    //city level
    if (index == 2) {
      // this.state.map_zone = '';
      this.state.map_city = '';
      this.state.map_store_code = '';
      this.state.map_store_name = '';
      this.state.map_level = 0;
      this.state.center_point = [0, 0];
      this.state.North_point = [72.6416015625, 37.71859032558816];
      this.state.South_point = [93.1640625, 5.7908968128719565];
      this.state.is_India_map_loaded = false;

      this.state.is_customer_metrices_loaded = false;
      this.state.is_sales_metrices_loaded = false;
      this.state.is_sales_graph_loaded = false;
      this.state.is_customer_graph_loaded = false;

      this.getIndiaMapCityDetails();

      this.forceUpdate();
    }
    // level 3
    //Store level
    if (index == 3) {
      // this.state.map_zone = '';
      //this.state.map_city = '';
      this.state.map_store_code = '';
      this.state.map_store_name = '';
      this.state.map_level = 0;
      this.state.center_point = [0, 0];
      this.state.North_point = [72.6416015625, 37.71859032558816];
      this.state.South_point = [93.1640625, 5.7908968128719565];
      this.state.is_India_map_loaded = false;

      this.getIndiaMapStoresDetails();


      this.forceUpdate();
    }
  }

  render() {
    const CarouselSettings = {
      arrows: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: false,
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 600,
          settings: {
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 1
          }
        }
      ]
    }

    const now = 40;
    const progress1 = 65; const progress2 = 25; const progress3 = 10;

    return (
      <Wrapper>
        <div className="grid drawer_grid ri_summary_bsImport">
          <div className="left_drawer col_span_1 fixed-left-grid mapRightWrapper" id="india_map">
            <div className="icz-rimapsection">
              {this.state.is_India_map_loaded == true ?
                <Wrapper>
                  <Col lg={12} className="icz-rimapsectionheader">
                    <Wrapper>
                      <Wrapper>
                        <Col lg={4} md={4} sm={12} className="icz-rimaptitle">
                          {this.state.country != null ? (this.state.country.toUpperCase() == "UK" ? "UK" : this.state.country.toUpperCase() == "US" ? "US" : "India") : "India"}
                        </Col>
                        <Col lg={8} md={8} sm={12} className="icz-rimapfilter">
                          <RiMapFilter
                            parentCallback={this.handleRiMapFilterCallback}
                            map_filter_category_list={this.state.map_filter_category_list}
                            map_filter_storetype_list={this.state.map_filter_storetype_list}
                            map_filter_storesize_list={this.state.map_filter_storesize_list}
                          />

                          <div className="icz-ribtnwrapper">
                            <button className="icz-rithemebtn">
                              <IconDownload className="icz-riicon" /> </button>
                          </div>
                        </Col>
                      </Wrapper>
                      <div className="breadcrumb-no-padding">
                        <Breadcrumb>
                          {this.state.mapBreadcrumbList.map((item, index) => (
                            <Breadcrumb.Item onClick={() => { this.mapBreadcrumbs(item, index + 1) }} key={index}>{item}</Breadcrumb.Item>
                          ))}
                        </Breadcrumb>
                      </div>
                    </Wrapper>
                  </Col>


                  <Col lg={12} className="icz-rimapcontainer">
                    {/* {this.state.is_India_map_loaded == true ?
                        <IndiaMap data={this.state.MapMarker}
                          parentCallback={this.handleRISalesSummaryIndiaMapCallBack}
                          North_point={this.state.North_point}
                          South_point={this.state.South_point}
                          Center_point={this.state.center_point}
                          map_level={this.state.map_level}
                          rangetype={this.state.rangetype}
                        />
                        : <Loader />} */}
                    {this.state.is_India_map_loaded == true ?
                      <>
                        {(() => {
                          switch (this.state.country) {
                            case "india": return <IndiaMap data={this.state.MapMarker}
                              parentCallback={this.handleRISalesSummaryIndiaMapCallBack}
                              North_point={this.state.North_point}
                              South_point={this.state.South_point}
                              Center_point={this.state.center_point}
                              map_level={this.state.map_level}
                              rangetype={this.state.rangetype}
                              ref={this.printRef}
                            />;
                            case "UK": return <UKMap
                              data={this.state.MapMarker}
                              parentCallback={this.handleRISalesSummaryIndiaMapCallBack}
                              North_point={this.state.North_point}
                              South_point={this.state.South_point}
                              Center_point={this.state.center_point}
                              map_level={this.state.map_level}
                              rangetype={this.state.rangetype}
                              ref={this.printRef}
                            ></UKMap>;
                            case "US": return <USMap
                              data={this.state.MapMarker}
                              parentCallback={this.handleRISalesSummaryIndiaMapCallBack}
                              North_point={this.state.North_point}
                              South_point={this.state.South_point}
                              Center_point={this.state.center_point}
                              map_level={this.state.map_level}
                              rangetype={this.state.rangetype}
                              ref={this.printRef}
                            ></USMap>;
                            default: return <IndiaMap data={this.state.MapMarker}
                              parentCallback={this.handleRISalesSummaryIndiaMapCallBack}
                              North_point={this.state.North_point}
                              South_point={this.state.South_point}
                              Center_point={this.state.center_point}
                              map_level={this.state.map_level}
                              rangetype={this.state.rangetype}
                              ref={this.printRef}
                            />;
                          }
                        })()}
                      </>
                      : <Loader />}
                  </Col>

                  <div className="icz-rimapfooter">
                    <Col lg={12}>
                      <ul className="icz-rilist-inline">
                        <li><div className="icz-rilist-bullet1" /> North</li>
                        <li><div className="icz-rilist-bullet2" /> West</li>
                        <li><div className="icz-rilist-bullet3" /> South</li>
                        <li><div className="icz-rilist-bullet4" /> East</li>
                        <li><div className="icz-rilist-bullet5" /> APTS</li>
                      </ul>
                    </Col>

                    <Col lg={12} className="icz-rimapprogressbar">
                      <h4 className="icz-riprogresstitle">NSV Achievement Percentage</h4>
                      <ProgressBar>
                        <ProgressBar className="range1" variant="range1" now={progress1} key={1} label="0-69" />
                        <ProgressBar className="range2" variant="range2" now={progress2} key={2} label="70-94" />
                        <ProgressBar className="range3" variant="range3" now={progress3} key={3} label="95+" />
                      </ProgressBar>
                    </Col>
                  </div>
                </Wrapper>
                : <Loader />}
            </div>
          </div>
          <div className="right_side col_span_3 relative-right-grid icz-ridatacontainer" style={{ padding: "0" }}>
            <div className="content">
              <div className="content_section">
                <PageHeader pageTitle={"Sell Through"} />
                <div className="page_content">
                  <div className="dashboard_home">

                    <div className="grid grid_cols_1 grid_margin_bottom" id='sell_through_score'>
                      <div className="icz-sectioncardwrapper w-100" style={{ "padding": "0" }}>
                        <div className="icz-sectioncard d-flex flex-row flex-wrap">
                          <Col sm={12} className="icz-cardheader">
                            <Col lg={10} className="icz-cardtitle">
                              Sell Through Score
                            </Col>
                            <Col lg={2} className="icz-cardfilter">
                              <ChartExport ChartId='sell_through_score' exportName="Sell Through Score"
                                export_href={this.state.export_href} downloadName="Sell Through Score.csv"
                              />
                            </Col>
                          </Col>
                          <div className="icz-risalessection">
                            <Col lg={12} className="d-flex align-items-start">
                              <Col lg={4} sm={12} className="icz-risalecontainer">
                                <MultipartGaugeChart chart_id="gauge_mtd" chart_class="icz-sectionchart" graph-data={this.state.mtd_gaugedata} />
                                <h5>MTD</h5>
                              </Col>
                              <Col lg={4} sm={12} className="icz-risalecontainer">
                                <MultipartGaugeChart chart_id="gauge_qtd" chart_class="icz-sectionchart" graph-data={this.state.qtd_gaugedata} />
                                <h5>QTD</h5>
                              </Col>
                              <Col lg={4} sm={12} className="icz-risalecontainer">
                                <MultipartGaugeChart chart_id="gauge_ytd" chart_class="icz-sectionchart" graph-data={this.state.ytd_gaugedata} />
                                <h5>YTD</h5>
                              </Col>
                              <Col lg={12} className="icz-ridatabullet">
                                <ul className="icz-ridatalist-inline">
                                  <li><div className="icz-ridatalist-bullet1" /> Format</li>
                                  <li><div className="icz-ridatalist-bullet2" /> Zone</li>
                                  <li><div className="icz-ridatalist-bullet3" /> City</li>
                                  <li><div className="icz-ridatalist-bullet4" /> Store</li>
                                </ul>
                              </Col>
                            </Col>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="grid grid_cols_1 grid_margin_bottom">
                      <div className="icz-ricardheader">
                        <div className="icz-ricardtitle">
                          Sell Through Metrics
                        </div>
                      </div>
                    </div>

                    <div className="grid col_span_4 icz-carouselcontainer  grid_margin_bottom">
                      <Carousel
                        Settings={CarouselSettings}
                        class={"icz-cardcontainer"}
                        SliderCards={[
                          <ChartCard
                            index="1"
                            CardClass="icz-cardwrapper"
                            CardIcon={<IconWebsite className="icz-icon" />}
                            CardTitle="NSV"
                            RowOneCurrentValue="25000000"
                            RowOnePreviousValue="20000000"
                            RowOneTitle="overall"
                            IsNumber={"number"}
                            chart={<Linegraph_sparkline card_id="icz-nsv" card_class="icz-cardchart" graph-data={this.state.linesparkgraph} />}
                          />,

                          <ChartCard
                            index="2"
                            CardClass="icz-cardwrapper"
                            CardIcon={<IconWebsite className="icz-icon" />}
                            CardTitle="SOH"
                            RowOneCurrentValue="6703475"
                            RowOnePreviousValue="6000000"
                            RowOneTitle="overall"
                            IsNumber={"number"}
                            chart={<Linegraph_sparkline card_id="icz-soh" card_class="icz-cardchart" graph-data={this.state.linesparkgraph} />}
                          />,
                          <ChartCard
                            index="3"
                            CardClass="icz-cardwrapper"
                            CardIcon={<IconWebsite className="icz-icon" />}
                            CardTitle="Units Sold"
                            RowOneCurrentValue="200000"
                            RowOnePreviousValue="150000"
                            RowOneTitle="overall"
                            IsNumber={"number"}
                            chart={<Linegraph_sparkline card_id="icz-units" card_class="icz-cardchart" graph-data={this.state.linesparkgraph} />}
                          />,
                          <ChartCard
                            index="4"
                            CardClass="icz-cardwrapper"
                            CardIcon={<IconWebsite className="icz-icon" />}
                            CardTitle="Sell Through%"
                            RowOneCurrentValue="3%"
                            RowOnePreviousValue="2.5%"
                            RowOneTitle="overall"
                            IsNumber={"number"}
                            chart={<Linegraph_sparkline card_id="icz-sell" card_class="icz-cardchart" graph-data={this.state.linesparkgraph} />}
                          />,
                          <ChartCard
                            index="5"
                            CardClass="icz-cardwrapper"
                            CardIcon={<IconWebsite className="icz-icon" />}
                            CardTitle="Markdown%"
                            RowOneCurrentValue="50%"
                            RowOnePreviousValue="40%"
                            RowOneTitle="overall"
                            IsNumber={"number"}
                            chart={<Linegraph_sparkline card_id="icz-markdown" card_class="icz-cardchart" graph-data={this.state.linesparkgraph} />}
                          />,
                          <ChartCard
                            index="6"
                            CardClass="icz-cardwrapper"
                            CardIcon={<IconWebsite className="icz-icon" />}
                            CardTitle="Basket Size"
                            RowOneCurrentValue="12547"
                            RowOnePreviousValue="10454"
                            RowOneTitle="overall"
                            IsNumber={"number"}
                            chart={<Linegraph_sparkline card_id="icz-basket" card_class="icz-cardchart" graph-data={this.state.linesparkgraph} />}
                          />
                        ]}>

                      </Carousel>
                    </div>

                    <div className="grid grid_cols_1 grid_margin_bottom">
                      <div className="icz-ricardheader">
                        <Col className="icz-ricardtitle">
                          Additional Metrics
                        </Col>
                      </div>
                    </div>
                    <div className="grid col_span_4 icz-carouselcontainer  grid_margin_bottom">
                      <Carousel
                        Settings={CarouselSettings}
                        class={"icz-cardcontainer"}
                        SliderCards={[
                          <ChartCard
                            index="1"
                            CardClass="icz-cardwrapper"
                            CardIcon={<IconWebsite className="icz-icon" />}
                            CardTitle="ASP"
                            RowOneCurrentValue="1300000"
                            RowOnePreviousValue="1300000"
                            RowOneTitle="overall"
                            IsNumber={"number"}
                            chart={<Linegraph_sparkline card_id="icz-asp" card_class="icz-cardchart" graph-data={this.state.linesparkgraph} />}
                          />,

                          <ChartCard
                            index="2"
                            CardClass="icz-cardwrapper"
                            CardIcon={<IconWebsite className="icz-icon" />}
                            CardTitle="NM%"
                            RowOneCurrentValue="29%"
                            RowOnePreviousValue="28%"
                            RowOneTitle="overall"
                            IsNumber={"number"}
                            chart={<Linegraph_sparkline card_id="icz-nm" card_class="icz-cardchart" graph-data={this.state.linesparkgraph} />}
                          />,
                          <ChartCard
                            index="3"
                            CardClass="icz-cardwrapper"
                            CardIcon={<IconWebsite className="icz-icon" />}
                            CardTitle="Wk Covr"
                            RowOneCurrentValue="60"
                            RowOnePreviousValue="0"
                            RowOneTitle="overall"
                            IsNumber={"number"}
                            chart={<Linegraph_sparkline card_id="icz-wkcovr" card_class="icz-cardchart" graph-data={this.state.linesparkgraph} />}
                          />,
                          <ChartCard
                            index="3"
                            CardClass="icz-cardwrapper"
                            CardIcon={<IconWebsite className="icz-icon" />}
                            CardTitle="Fwd Wk Covr"
                            RowOneCurrentValue="40"
                            RowOnePreviousValue="45"
                            RowOneTitle="overall"
                            IsNumber={"number"}
                            chart={<Linegraph_sparkline card_id="icz-fwd" card_class="icz-cardchart" graph-data={this.state.linesparkgraph} />}
                          />,
                          <ChartCard
                            index="4"
                            CardClass="icz-cardwrapper"
                            CardIcon={<IconWebsite className="icz-icon" />}
                            CardTitle="ROS%"
                            RowOneCurrentValue="5%"
                            RowOnePreviousValue="6%"
                            RowOneTitle="overall"
                            IsNumber={"number"}
                            chart={<Linegraph_sparkline card_id="icz-ros" card_class="icz-cardchart" graph-data={this.state.linesparkgraph} />}
                          />,
                          <ChartCard
                            index="12"
                            CardClass="icz-cardwrapper"
                            CardIcon={<IconWebsite className="icz-icon" />}
                            CardTitle="PSFPD"
                            RowOneCurrentValue="80"
                            RowOnePreviousValue="0.000001"
                            RowOneTitle="overall"
                            IsNumber={"number"}
                            chart={<Linegraph_sparkline card_id="icz-psfpd" card_class="icz-cardchart" graph-data={this.state.linesparkgraph} />}
                          />,
                          <ChartCard
                            index="5"
                            CardClass="icz-cardwrapper"
                            CardIcon={<IconWebsite className="icz-icon" />}
                            CardTitle="MBQ%"
                            RowOneCurrentValue="132%"
                            RowOnePreviousValue="0.0001"
                            RowOneTitle="overall"
                            IsNumber={"number"}
                            chart={<Linegraph_sparkline card_id="icz-mbq" card_class="icz-cardchart" graph-data={this.state.linesparkgraph} />}
                          />
                        ]}>

                      </Carousel>
                    </div>


                    <div className="grid grid_cols_1  grid_margin_bottom" id='Sell_Through_Trend'>
                      <div className="icz-sectioncardwrapper w-100">
                        <div className="icz-sectioncard">
                          <Col sm={12} className="icz-cardheader">
                            <Col lg={10} className="icz-cardtitle">
                              Sell Through Trend
                            </Col>
                            <Col lg={2} className="icz-cardfilter">
                              <ChartExport ChartId='Sell_Through_Trend' exportName="Sell Through Trend"
                                export_href={this.state.export_href} downloadName="Sell Through Trend.csv"
                              />
                            </Col>
                          </Col>
                          <div className="">
                            <HighlightingLineChart chart_id="sellthrough_trend" chart_class="icz-sectionchart" graph-data={this.state.selltrend} metric_1={"PB"} metric_2={"FLFL"} metric_3={"Footwear"} metric_4={"Sports"} metric_5={"Luggage & Bagpacks"} metric_6={"Accessories"} />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="grid grid_cols_1" id='Category_Sell_Through_Deep-dive'>
                      <div className="icz-sectioncardwrapper w-100">
                        <div className="icz-sectioncard">
                          <Col sm={12} className="icz-cardheader">
                            <Col lg={10} className="icz-cardtitle">
                              Category Sell Through Deep-dive
                            </Col>
                            <Col lg={2} className="icz-cardfilter">
                              <ChartExport ChartId='Category_Sell_Through_Deep-dive' exportName="Category Sell Through Deep-dive"
                                export_href={this.state.export_href} downloadName="Category Sell Through Deep-dive.csv"
                              />
                            </Col>
                          </Col>
                          <div className="">
                            <RiTreegraph card_id="icz-treemap" card_class="icz-sectionchart"
                              graph-data={this.state.treegraph}
                              parentCallback={this.handleNSVdeepDiveCallback}
                              parentCallback2={this.handleNSVdeepDiveCallback2}
                              Level_Counter={this.state.Deep_Dive_level}
                              Deep_Dive_BreadCrumb={this.state.Deep_Dive_Name}
                              isnumber={'money'}
                              dropdownValue={this.state.category_dropdown_value}
                            />
                          </div>
                          <div>
                            <Col lg={12} className="icz-ridatabullet">
                              <ul className="icz-ridatalist-inline">
                                <li>Area = SOH</li>
                                <li><div className="icz-ridatalist-bullet5" /> High Sell Through rate%</li>
                                <li><div className="icz-ridatalist-bullet2" /> Med Sell Through rate%</li>
                                <li><div className="icz-ridatalist-bullet6" /> Low Sell Through rate%</li>

                              </ul>
                            </Col>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="grid grid_cols_1 icz-datacontainer">
                      <div className="icz-sectiontabscontainer">
                        <div className="icz-tabscontrols">
                          <TabNav tabs={['Performance', 'Exceptions']} icon={[<IconPerformance className="icz-tabicon" />, <IconRemarketing className="icz-tabicon" />]} selected={this.state.selectedSubNav} setSelected={this.setSelectedSubNav}>
                            <Tab isSelected={this.state.selectedSubNav === 'Performance'}>
                              <SellthroughPerformance />
                            </Tab>
                            <Tab isSelected={this.state.selectedSubNav === 'Exceptions'}>
                              <SellthroughExceptions />
                            </Tab>
                          </TabNav>
                        </div>
                      </div>
                    </div>

                    <div className="grid grid_cols_1 grid_margin_bottom">
                      <div className="icz-sectioncardwrapper w-100">
                        <div className="icz-sectioncard">
                          <Col sm={12} className="icz-cardheader">
                            <Col className="icz-cardtitle">
                              Markdown Optimization
                            </Col>
                            <Col className="icz-cardfilter">
                              <Dropdown dropdown_options={this.state.markdownasp_dropdown_options} dropdown_placeholder="Markdown" parentCallback={this.handleCallback} />
                              <ChartExport
                                ChartId='markdownOptimization'
                                export_data={this.state.markdownData}
                                downloadName="Markdown Optimization"
                              />
                            </Col>
                          </Col>
                          <div className="">
                            <RiHeatMap chart_id="markdownOptimization" chart_class="icz-sectionchart" graph-data={this.state.markdownData} />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="grid grid_cols_1">
                      <div className="icz-sectioncardwrapper w-100">
                        <div className="icz-sectioncard">
                          <Col sm={12} className="icz-cardheader  flex-wrap">
                            <Col className="icz-cardtitle">
                              Markdown Optimization
                            </Col>
                            <Col className="icz-cardfilter">
                              <Dropdown dropdown_options={this.state.markdown_dropdown_options} dropdown_placeholder="Promo" parentCallback={this.handleCallback} />
                              <ChartExport
                                ChartId='promoMarkdownOptimization'
                                export_data={this.state.markdownData}
                                downloadName="Promo Markdown Optimization"
                              />
                            </Col>
                          </Col>
                          <div className="">
                            <RiHeatMap chart_id="promo_markdown-optimization" chart_class="icz-sectionchart" graph-data={this.state.markdownData} />
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Wrapper >
    )
  }
}

function ReduxStateToProps(state) {
  return {
    start_date: state.date.startDate,
    end_date: state.date.endDate,
    previous_start_date: state.date.prevStartDate,
    previous_end_date: state.date.prevEndDate,
    country: state.userData.user.country_code
  };
}

export default connect(ReduxStateToProps)(SellThroughOverview)